import { UserStateType } from './state'

export interface UserGettersType {
  getUserById: (state: UserStateType) => UserStateType['user']
}

export const UserGetters = {
  getUserById: (state: UserStateType) => state.user,
}
